
import { Component, Prop, Watch } from 'vue-property-decorator'
import Mixin from '../helpers/mixin'

@Component({
  template: `
    <div class="contact-anchor contact-anchor contact-anchor__wrap">
        <div class="contact-anchor__button flex" v-if='hrefLocation.length > 1' @click='scrollToView(hrefLocation)'>
          <i aria-hidden="true" class="icons8-chat-message"></i>
          <transition>
            <div class="contact-anchor__button-text">
              {{ title }}
              <i aria-hidden="true" class="icons8-chevron-down-2"></i>
            </div>
          </transition>
        </div>
    </div>
  `
})
export default class ContactAnchorButton extends Mixin {
  @Prop() headerHeight: number
    @Prop() productDetail: boolean

  contactId = ''
  title: string | null = ''
  width = this.isPhone || this.isTabletP ? window.outerWidth + 'px' : 'unset'

  get offsetTopSideMenu(): string {
    return (this.isPhone || this.isTabletP ? this.headerHeight : this.headerHeight + 10) + 'px'
  }

  get hrefLocation(): string {
    return `${this.contactId}`
  }

  scrollToView(id: string) {
    const element = document.getElementById(id);
    const headerOffset = 135;

    const productDetailPage = document.querySelector('.hero-text-media__sticky');
    const stickyProductDetail = document.querySelector('.hero-text-media__sticky.sticky');

    if(element){
      const elementPosition = element.getBoundingClientRect().top;
      let offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      if(productDetailPage && !stickyProductDetail && this.isPhone || this.isTabletP) offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      if(productDetailPage && !stickyProductDetail) offsetPosition = elementPosition + window.pageYOffset - 400;
      else offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  }


  placeButton(): void {
    const mainElement = document.querySelector('main')
    const buttonElement = document.querySelector('.contact-anchor')

    const firstContact = document.querySelector('.contact')
    if (buttonElement) buttonElement.remove()

    if (buttonElement && mainElement) {
      if (firstContact && mainElement.firstChild != firstContact && mainElement.children[1] != firstContact) {
        this.contactId = firstContact.id
        if (firstContact.firstChild && firstContact.firstChild.firstChild)
          this.title = firstContact.firstChild.firstChild.textContent
      } else {
        buttonElement.children[1]?.firstChild?.remove()
      }

      mainElement.appendChild(buttonElement)
    }
  }

  updateWidth() {
    this.width = this.isPhone || this.isTabletP ? window.outerWidth + 'px' : 'unset'
  }

  mounted(): void {
    window.addEventListener('resize', this.updateWidth)
    this.$nextTick(() => this.placeButton())
    this.$nextTick(() => this.updateWidth())
  }

  @Watch('isPhone')
  onIsPhoneChange() {
    this.placeButton()
  }

  @Watch('isTabletP')
  onIsTabletP() {
    this.placeButton()
  }

}
